export default __webpack_public_path__ + "static/media/portfolio-79.1d56d7ca.jpg";